export type AppVariant =
  | 'reader'
  | 'studio'
  | 'home'

type VariantRule =
  | { variant: AppVariant; prefix: string }   // matches /prefix...
  | { variant: AppVariant; path: string }     // matches exact path

const VARIANT_RULES: VariantRule[] = [
  { variant: 'home', path: '/demos' },
  { variant: 'studio', prefix: '/studio' },
  { variant: 'reader', prefix: '/reader' },
  { variant: 'home', path: '/' },
]

function isPrefixMatch(path: string, prefix: string) {
  return path === prefix || path.startsWith(prefix + '/')
}

function resolveVariantFromPath(path: string): AppVariant {
  const cleaned = path !== '/' ? path.replace(/\/+$/, '') : '/'

  for (const rule of VARIANT_RULES) {
    if ('path' in rule) {
      if (cleaned === rule.path) return rule.variant
      continue
    }
    if (isPrefixMatch(cleaned, rule.prefix)) return rule.variant
  }

  return 'reader'
}

function resolveVariant(routePath: string): AppVariant {
  return resolveVariantFromPath(routePath)
}

export function useAppVariant(): { variant: ComputedRef<AppVariant> } {
  const route = useRoute()

  const variant = computed<AppVariant>(() => resolveVariant(route.path))

  return { variant }
}
